module.exports = __webpack_public_path__ + "img/UZ.f6eea83f.svg";